import * as React from 'react';
import { Col, notification, Row, Skeleton } from 'antd';
import { FileSearchOutlined } from '@ant-design/icons';

import './index.scss';
import { useEffect, useState } from 'react';
import ProductCard from '../ProductCard/ProductCard';
import API_SERVICE from 'shared/services/api-service';
import { useTranslation } from 'react-i18next';
import Title from 'antd/es/typography/Title';
import { useParams } from 'react-router-dom';
import { useLocation, useMedia } from 'react-use';

export default function ProductCardGrid({
                                            numberOfCourses,
                                            selectedLevel,
                                            isFeatured,
                                            isPopular,
                                            search,
                                            selectedCategory,
                                            selectedPlan,
                                        }: any) {
    const [products, setProducts] = useState([] as any);
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();
    const RouteParams: any = useParams();

    const location = useLocation();
    const params: any = {
        per_page: numberOfCourses || 100,
    };

    const refreshAllCourses = () => {
        API_SERVICE.fetchCourses(params).then((courses) => {
            setProducts(courses.data.data.items);
        }).catch((e) => {
            notification.error({
                message: API_SERVICE.handleErrors(e),
            });
        }).finally(() => {
            setLoading(false);
        });
    };
    const refreshFavourite = () => {
        API_SERVICE.fetchFavouriteCourses(params).then((courses) => {
            setProducts(courses.data.data.items.map((m: any) => {
                return m.course;
            }));
        }).catch((e) => {
            notification.error({
                message: API_SERVICE.handleErrors(e),
            });
        }).finally(() => {
            setLoading(false);
        });
    };
    // const refreshMyCourses = () => {
    //     API_SERVICE.fetchMyCourses(params).then((courses) => {
    //         setProducts(courses.data.data.items.map((m: any) => {
    //             return {...m.product, isCompleted: m.isCompleted || m.is_completed};
    //         }));
    //     }).catch((e) => {
    //         notification.error({
    //             message: API_SERVICE.handleErrors(e),
    //         });
    //     }).finally(() => {
    //         setLoading(false);
    //     });
    // };
    const refresh = () => {
        if (selectedLevel && selectedLevel !== -1) {
            params['level_id'] = selectedLevel;
        } else {
            delete params['level_id'];
        }
        if (search) {
            params['q'] = search;
        } else {
            delete params['q'];
        }
        if (isFeatured) {
            params['is_featured'] = true;
        } else {
            delete params['is_featured'];
        }
        if (isPopular) {
            params['is_popular'] = true;
        } else {
            delete params['is_popular'];
        }
        if (selectedPlan) {
            params['price_plan'] = selectedPlan;
        } else {
            delete params['price_plan'];
        }
        if (selectedCategory && selectedCategory !== -1) {
            params['category_id'] = selectedCategory;
        } else {
            delete params['category_id'];
        }
        if (!RouteParams['mode']) {
            refreshAllCourses();
        } else if (RouteParams['mode'] === 'courses') {
            // refreshMyCourses();
        } else if (RouteParams['mode'] === 'favourites') {
            refreshFavourite();
        }
    };
    useEffect(() => {
        setLoading(true);
        refresh();

    }, [location, isPopular, selectedPlan,isFeatured, selectedCategory, search, selectedLevel]);

    return <div className={'product-card-grid-wrapper'} style={{padding: '10px'}}>
        {loading ? <Skeleton active={true}/> : <Row gutter={[20, 20]} justify="start">

            {
                products.length ? products.map((product : any) => {
                    return<>
                        {
                            product.course && product.course.map((productCourse: any) => {
                                return<ProductCard refresh={refresh} item={productCourse}/>
                            })
                        }
                    </>
                }) : <Col span={24} className={'text-center'} style={{ opacity: '0.3' }}>
                    <Title level={1}>{t('genDict.noResultFound')}</Title>
                    <FileSearchOutlined style={{ fontSize: '50px' }}/>
                </Col>
            }
        </Row>}
    </div>;

}
